var chunkMapping = {
	"329": [
		24329
	],
	"339": [
		91981,
		61935,
		13372,
		69959,
		12332
	],
	"398": [
		24963,
		17693,
		66467,
		71290
	],
	"474": [
		33359
	],
	"565": [
		29684,
		30828,
		31450,
		33457,
		36744,
		45620,
		48845,
		49283,
		49518,
		52391,
		54064,
		55894,
		72098,
		73580
	],
	"777": [
		28122,
		55805,
		99040
	],
	"815": [
		51426,
		55843,
		88804
	],
	"859": [
		60859
	],
	"908": [
		53733,
		84488
	]
};
var idToExternalAndNameMapping = {
	"12332": [
		"default",
		"./utils",
		32436
	],
	"13372": [
		"default",
		"./sagas",
		32436
	],
	"17693": [
		"default",
		"./Selectors",
		41441
	],
	"24329": [
		"default",
		"./utils",
		86784
	],
	"24963": [
		"default",
		"./History",
		41441
	],
	"28122": [
		"default",
		"./LookEmbed",
		53550
	],
	"29684": [
		"default",
		"./UnboxingPageCrossSelling",
		96308
	],
	"30828": [
		"default",
		"./UnboxingPageIntroduction",
		96308
	],
	"31450": [
		"default",
		"./register",
		32436
	],
	"33359": [
		"default",
		"./RewardItemsBuilder",
		90990
	],
	"33457": [
		"default",
		"./Utils",
		77672
	],
	"36744": [
		"default",
		"./UnboxingPage",
		96308
	],
	"45620": [
		"default",
		"./UnboxingPageRow",
		96308
	],
	"48845": [
		"default",
		"./Store",
		77672
	],
	"49283": [
		"default",
		"./unboxing-page",
		96308
	],
	"49518": [
		"default",
		"./UnboxingPageDocumentation",
		96308
	],
	"51426": [
		"default",
		"./RewardSelect",
		90990
	],
	"52391": [
		"default",
		"./UnboxingPageHeader",
		96308
	],
	"53733": [
		"default",
		"./RewardTags",
		90990
	],
	"54064": [
		"default",
		"./UnboxingPageIntegrationBanner",
		96308
	],
	"55805": [
		"default",
		"./PredicateSummaryWithFetchData",
		86784
	],
	"55843": [
		"default",
		"./SchedulePicker",
		86784
	],
	"55894": [
		"default",
		"./UnboxingPageCol",
		96308
	],
	"60859": [
		"default",
		"./Services",
		90990
	],
	"61935": [
		"default",
		"./hooks",
		32436
	],
	"66467": [
		"default",
		"./hooks",
		41441
	],
	"69959": [
		"default",
		"./styles",
		32436
	],
	"71290": [
		"default",
		"./constants",
		90990
	],
	"72098": [
		"default",
		"./authorize",
		32436
	],
	"73580": [
		"default",
		"./UnboxingPageBody",
		96308
	],
	"84488": [
		"default",
		"./Changelog",
		86784
	],
	"88804": [
		"default",
		"./InlineSegmentationBuilder",
		86784
	],
	"91981": [
		"default",
		"./components",
		32436
	],
	"99040": [
		"default",
		"./CopyToClipboard",
		86784
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}